import styled from "styled-components";
import Color from "../../../assets/styles/colors";

export const Container = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const Div = styled.div``;

export const ProfileInfo = styled.div``;

export const Name = styled.div`
  font-size: 16px;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackSeven : Color.textColorBlack};
`;

export const Phone = styled.div`
  font-size: 12px;
  line-height: 1.833;
  color: ${Color.textColorBlackEight};
`;

export const ProfileLevel = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  background: #47879f;
  padding: 4px;
  border-radius: 8px;
  font-size: 12px;
  color: ${Color.colorWhite};
`;

export const ProfileItem = styled.span`
  color: #bababa;
  font-size: 13px;
`;

export const ProfileItemValue = styled.span`
  color: #939393;
  font-size: 15px;
  display: block;
  margin-top: 0.5rem !important;
`;

export const ProfileContainer = styled.div`
  border-bottom: 1px solid
    ${(props) =>
      props.theme.isDarkTheme ? Color.textColorBlackOne : "#dfdfdf"};
  padding: 20px !important;
`;

export const EditIcon = styled.i`
  color: #81858b;
  font-size: 18px !important;
`;
